// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"TwoLineGridCell_firstLine__3lJuf","firstLineBlock":"TwoLineGridCell_firstLineBlock__2onUa","secondLine":"TwoLineGridCell_secondLine__QdbB3"};